module.exports = __webpack_public_path__ + "static/img/20096B_2_3_C_20211023_LC.65843aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/20096B_2_3_C_20211023_LC.png
// module id = 3vEN
// module chunks = 0